enum LocalStorageKeys {
  marketplaceId = 'MARKETPLACE_ID',
  discussionListingSortBy = 'DISCUSSION_LISTING_SORT_BY',
  discussionListingDateRange = 'DISCUSSION_LISTING_DATE_RANGE',
}

export default LocalStorageKeys;
